import { render, staticRenderFns } from "./InvoiceItemModal.vue?vue&type=template&id=b962c100"
import script from "./InvoiceItemModal.vue?vue&type=script&lang=js"
export * from "./InvoiceItemModal.vue?vue&type=script&lang=js"
import style0 from "./InvoiceItemModal.vue?vue&type=style&index=0&id=b962c100&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports